(() => {
  if (customElements.get('copirema-thesis-calculator')) return;

  const PAPER_LABELS = {
    '80': '80 grammi', '100-OPACO': '100 grammi opaca', '100-LUCIDO': '100 grammi lucido',
    '120-OPACO': '120 grammi opaco', '120-LUCIDO': '120 grammi lucido',
    '80-RICICLATA': '80 grammi riciclata', '100-AVORIO': '100 grammi avorio'
  };


  const COVER_DISCOUNT_GROUPS = [
    {
      key: 'TINTA_UNITA',
      rates: { 2: 1000, 3: 3000, 4: 4000, 5: 5000 },
      products: ['BORDEAUX WINE','MAGENTA','VIOLA LUCIDO','LILLA','PESCA','ROSA CIPRIA','ROSA PALLIDO','ROSA BARBIE','BISCOTTO','AVORIO MARMORIZZATO','AVORIO','CHAMPAGNE','BIANCO GHIACCIO','BLUE NARCOTIQUE','BLU ZAFFIRO','BLUE ROYAL','AZZURRO CARTA DA ZUCCHERO','AZZURRO LUCIDO','VERDE PINO','VERDE MUSCHIO','GIALLO SENAPE','ZUCCA','NERO OPACO','NERO LUCIDO','GRIGIO TOPO','GRIGIO CHIARO','FANGO','GRIGIO ANTRACITE','AMARANTO']
    },
    {
      key: 'SPECIALI',
      rates: { 2: 800, 3: 2400, 4: 3200, 5: 4000 },
      products: ['VINACCIA','ROSSO FUOCO','ROSSO CAMELIA','FUCSIA FLAMENCO','FUCSIA CICLAMINO','VIOLETTA DI PARMA','GLICINE','ROSA ANTICO','ROSA COSMICO','ROSA DIVINO','BIANCO PORCELLANA','BIANCO CRISTALLO',"LUNA D'ORO",'BIANCO COSMICO','POLVERE','BLU MAJORELLE','BLU MEZZANOTTE','BLUE TALISMAN','BLU OLTREMARE','BLU COSMICO','MENTA COSMICO','PETROLIO','VERDE PERSIANO','VERDE FORESTA','VERDE MELA','NERO COSMICO','NERO GRAFITE','CREMA','SABBIA','LOVE GOLD','PERLA']
    },
    {
      key: 'PREMIUM',
      rates: { 2: 800, 3: 2400, 4: 3200, 5: 4000 },
      products: ['ROSSO PELLE','SETA CILIGIA','SETA ROSSA','ROSSO NATURALE','ROSSO VELLUTO','ROSA PEONIA','ROSA MIRABILIS','ROSA FENICOTTERO','ROSA CORALLO','FUCSIA NATURALE','FUCSIA VELLUTO','ORCHIDEA NATURALE','SETA VIOLA','VIOLA ORTENSIA','PELLE VIOLA','IRIS','LILLA VELLUTO','LAVANDA NATURALE','BLU RIO','BLU NAVY','BLU PELLE','BLU NATURALE','INDACO NATURALE','BLU VELLUTO','AZZURRO CINDERELLA','AZZURRO NATURALE','TURCHESE NATURALE','VERDE BOTTIGLIA','TIFFANY','TIFFANY SETA','OTTANIO','VERDE TRIFOGLIO','SALVIA VELLUTO','PISTACCHIO','VERDE BOSCO','VERDE SMERALDO','VERDE VELLUTO','VERDE PELLE','VERDE NATURALE','CIOCCOLATO','CACAO CAVALLINO','CAVALLINO CARAMELLO','NOCE','NOCCIOLA','TOFFIE','BEIGE CAVALLINO','BEIGE NATURALE','NUDE VELLUTO','PLATINO','CAROTA','ACE','GIALLO LIMONE','GRIGIO CAVALLINO','VERDE SALVIA','VERDE OLIVA','FIORDALISO','CERULEO','ROSSO RUBINO','BORGOGNA','AZZURRO MARE']
    },
    {
      key: 'BASICHE',
      rates: { 2: 600, 3: 1800, 4: 2400, 5: 3000 },
      products: ['ROSSO FIOCCO','PORPORA','FUCSIA','HOLLYWOOD','ROSA CONFETTO','AZZURRO BABY','BLU EGIZIANO','BLU FIOCCO','VERDE ERBA','VERDE GIADA','VERDE LIME','ARANCIONE','BIANCO KELLT','BEIGE KELLY','ROSA BABY','ZAFFERANO','ROSSO RIBES','VERDE BASILICO','ROSA BLUSH','VANIGLIA','MANDORLA','BLU OXFORD','ROSSO SANGRIA']
    },
    {
      key: 'SIMILPELLE_CLASSICHE',
      rates: { 2: 1000, 3: 3000, 4: 4000, 5: 5000 },
      products: ['ROSSO MARMORIZZATO','ROSSO LUCIDO','BLU MARMORIZZATO','VERDE MARMORIZZATO','BORDEAUX MARMORIZZATO']
    }
  ].map((group) => ({ ...group, normalized: new Set(group.products.map(normalizeProductName)) }));

  class CopiremaThesisCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.miniThesis = this.dataset.miniThesis === 'true';
      this.form = document.getElementById(this.dataset.productFormId);
      this.wizardOnly = this.dataset.wizardOnly === 'true';
      if (this.wizardOnly) {
        this.activateWizardLaunch();
        return;
      }
      this.paperInput = this.querySelector('[data-paper]');
      this.colorModeInput = this.querySelector('[data-color-mode]');
      this.printModeInput = this.querySelector('[data-print-mode]');
      this.paperNotice = this.querySelector('[data-paper-notice]');
      this.pdfList = this.querySelector('[data-pdf-list]');
      this.pdfTemplate = this.querySelector('[data-pdf-template]');
      this.wordInput = this.querySelector('input[name="properties[Frontespizio Word]"]');
      this.wordField = this.querySelector('[data-word-field]');
      this.wordPresent = this.querySelector('[data-word-present]');
      this.contactSection = this.querySelector('[data-contact-section]');
      this.contactPresent = this.querySelector('[data-contact-present]');
      this.orderPhoneInput = this.querySelector('[data-order-phone]');
      this.coverPreviewText = this.querySelector('[data-cover-preview-text]');
      this.coverPreviewStatus = this.querySelector('[data-cover-preview-status]');
      this.duplexWarning = this.querySelector('[data-duplex-warning]');
      this.duplexConfirm = this.querySelector('[data-duplex-confirm]');
      this.errorBox = this.querySelector('[data-error]');
      this.progress = this.querySelector('[data-progress]');
      this.result = this.querySelector('[data-result]');
      this.variants = this.readVariants();
      this.coverVariants = this.readCoverVariants();
      this.entries = new Map();
      this.analysisQueue = Promise.resolve();
      this.submitting = false;

      this.form?.addEventListener('submit', (event) => this.onSubmit(event), true);
      this.wordField.hidden = true;
      if (this.contactSection) this.contactSection.hidden = true;
      this.cartStatePromise = this.refreshWordState();
      this.hideBypassButtons();
      this.wordInput?.addEventListener('change', () => this.updateCoverPreview());
      this.form?.addEventListener('change', () => this.updateEngravingPreview());

      if (this.miniThesis) return;

      this.prepareCoverQuantity();
      this.form?.addEventListener('change', () => this.updateCoverTotal(Math.max(1, this.calculateTotals().copies || 1)));
      this.updateCoverTotal(1);
      this.querySelector('[data-add-pdf]')?.addEventListener('click', () => this.addPdfRow());
      this.paperInput?.addEventListener('change', () => {
        this.applyPaperRules();
        this.renderAggregate();
      });
      this.printModeInput?.addEventListener('change', () => {
        this.updateDuplexWarning();
        this.updateRowStatuses();
        this.applyPaperRules();
        this.renderAggregate();
      });
      this.colorModeInput?.addEventListener('change', () => {
        this.updateColorHelp();
        this.renderAggregate();
      });
      this.addPdfRow();
      this.updateColorHelp();
      this.updateDuplexWarning();
      if (!this.hasCompleteVariantMap()) this.disablePurchase();
    }

    activateWizardLaunch() {
      const wizardUrl = this.dataset.wizardUrl || '';
      const fallback = this.querySelector('.copirema-thesis__wizard-fallback');
      const form = this.form;
      if (!wizardUrl || !form) {
        if (fallback) fallback.hidden = false;
        return;
      }

      const quantity = form.querySelector('.product-form__quantity');
      if (quantity) quantity.hidden = true;

      const paymentButton = form.querySelector('.shopify-payment-button');
      if (paymentButton) paymentButton.hidden = true;

      const addButton = form.querySelector('[name="add"]');
      if (!addButton) {
        if (fallback) fallback.hidden = false;
        return;
      }

      const label = 'Configura e ordina la tua tesi';
      const applyButtonState = () => {
        if (addButton.disabled) return;
        if (addButton.type !== 'button') addButton.type = 'button';
        if (addButton.hasAttribute('name')) addButton.removeAttribute('name');
        if (addButton.textContent.trim() !== label) addButton.textContent = label;
        addButton.dataset.copiremaWizardLaunch = 'true';
      };

      applyButtonState();
      const buildWizardUrl = () => {
        const url = new URL(wizardUrl, window.location.origin);
        const variantId = String(form.querySelector('input[name="id"]')?.value || '');
        const price = this.coverVariants.get(variantId);
        const params = {
          cover: this.dataset.productHandle || '',
          cover_id: this.dataset.productId || '',
          cover_title: this.dataset.productTitle || '',
          cover_url: this.dataset.productUrl || '',
          cover_image: this.dataset.productImage || '',
          cover_variant: variantId,
          cover_price: Number.isFinite(price) ? String(price) : ''
        };
        Object.entries(params).forEach(([key, value]) => {
          if (value !== '') url.searchParams.set(key, value);
        });
        return `${url.pathname}${url.search}${url.hash}`;
      };

      if (!addButton.disabled) {
        addButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign(buildWizardUrl());
        }, true);

        const observer = new MutationObserver(() => applyButtonState());
        observer.observe(addButton, { childList: true, subtree: true, characterData: true });
      }
      if (fallback) fallback.hidden = true;
    }

    readVariants() {
      try {
        const rows = JSON.parse(this.querySelector('[data-print-variants]')?.textContent || '[]');
        return new Map(rows.filter((row) => row.sku).map((row) => [row.sku.trim().toUpperCase(), row]));
      } catch (error) {
        console.error('Configurazione varianti stampa non valida', error);
        return new Map();
      }
    }

    readCoverVariants() {
      try {
        const rows = JSON.parse(this.querySelector('[data-cover-variants]')?.textContent || '[]');
        return new Map(rows.map((row) => [String(row.id), Number(row.price || 0)]));
      } catch (error) {
        console.error('Configurazione prezzi copertina non valida', error);
        return new Map();
      }
    }

    hasCompleteVariantMap() {
      if (this.dataset.ready !== 'true') return false;
      return Object.keys(PAPER_LABELS).every((paper) => {
        const bw = this.variants.get(`COP-${paper}-BN`);
        const color = this.variants.get(`COP-${paper}-COLORE`);
        return bw?.id && color?.id && bw.available && color.available;
      });
    }

    prepareCoverQuantity() {
      this.quantityInput = this.form?.querySelector('[name="quantity"]');
      if (!this.quantityInput && this.form) {
        this.quantityInput = document.createElement('input');
        this.quantityInput.type = 'hidden';
        this.quantityInput.name = 'quantity';
        this.quantityInput.value = '1';
        this.form.appendChild(this.quantityInput);
      }
      const wrapper = this.quantityInput?.closest('.product-form__quantity');
      if (wrapper) wrapper.hidden = true;
    }

    addPdfRow() {
      const fragment = this.pdfTemplate.content.cloneNode(true);
      const row = fragment.querySelector('[data-pdf-row]');
      const input = row.querySelector('[data-pdf-input]');
      const copies = row.querySelector('[data-pdf-copies]');
      const dropzone = row.querySelector('[data-dropzone]');
      this.entries.set(row, { file: null, analysis: null, analyzing: false });
      this.pdfList.appendChild(fragment);
      input.setAttribute('form', this.dataset.productFormId);

      input.addEventListener('change', () => {
        const file = input.files?.[0];
        if (!file) return;
        const entry = this.entries.get(row);
        entry.file = file;
        entry.analysis = null;
        row.querySelectorAll('[data-frontespizio-choice]').forEach((choice) => { choice.checked = false; });
        const frontCheck = row.querySelector('[data-frontespizio-check]');
        if (frontCheck) frontCheck.hidden = true;
        const frontHelp = row.querySelector('[data-frontespizio-help]');
        if (frontHelp) frontHelp.hidden = true;
        const frontError = row.querySelector('[data-frontespizio-error]');
        if (frontError) frontError.hidden = true;
        row.querySelector('[data-frontespizio-check]')?.classList.remove('is-invalid');
        row.querySelector('[data-drop-label]').textContent = file.name;
        row.querySelector('[data-pdf-status]').textContent = 'In coda per l’analisi…';
        this.result.hidden = true;
        this.analysisQueue = this.analysisQueue.then(() => this.analyzeRow(row)).catch((error) => console.error(error));
      });
      copies.addEventListener('input', () => {
        copies.value = String(Math.max(1, Math.min(99, parseInt(copies.value || '1', 10) || 1)));
        this.renumberRows();
        this.renderAggregate();
      });
      row.querySelectorAll('[data-frontespizio-choice]').forEach((choice) => {
        choice.addEventListener('change', () => {
          if (choice.checked) row.querySelectorAll('[data-frontespizio-choice]').forEach((other) => { if (other !== choice) other.checked = false; });
          const help = row.querySelector('[data-frontespizio-help]');
          if (help) help.hidden = choice.value !== 'present';
          const inlineError = row.querySelector('[data-frontespizio-error]');
          if (inlineError) inlineError.hidden = true;
          row.querySelector('[data-frontespizio-check]')?.classList.remove('is-invalid');
          this.clearError();
        });
      });
      row.querySelector('[data-remove-pdf]').addEventListener('click', () => this.removePdfRow(row));
      dropzone.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); input.click(); }
      });
      ['dragenter', 'dragover'].forEach((name) => dropzone.addEventListener(name, () => dropzone.classList.add('is-over')));
      ['dragleave', 'drop'].forEach((name) => dropzone.addEventListener(name, () => dropzone.classList.remove('is-over')));
      this.renumberRows();
      this.renderAggregate();
    }

    removePdfRow(row) {
      const entry = this.entries.get(row);
      if (entry?.analyzing) return this.showError('Attendi la fine dell’analisi prima di rimuovere questo PDF.');
      if (this.entries.size <= 1) {
        const input = row.querySelector('[data-pdf-input]');
        if (input) input.value = '';
        entry.file = null;
        entry.analysis = null;
        row.querySelectorAll('[data-frontespizio-choice]').forEach((choice) => { choice.checked = false; });
        const frontCheck = row.querySelector('[data-frontespizio-check]');
        if (frontCheck) { frontCheck.hidden = true; frontCheck.classList.remove('is-invalid'); }
        const frontError = row.querySelector('[data-frontespizio-error]');
        if (frontError) frontError.hidden = true;
        row.querySelector('[data-drop-label]').textContent = 'Trascina qui il PDF oppure scegli il file';
        row.querySelector('[data-pdf-status]').textContent = 'In attesa del file';
      } else {
        this.entries.delete(row);
        row.remove();
      }
      this.clearError();
      this.renumberRows();
      this.renderAggregate();
    }

    renumberRows() {
      const rows = [...this.entries.keys()];
      rows.forEach((row, index) => {
        const number = index + 1;
        const copies = this.getRowCopies(row);
        const input = row.querySelector('[data-pdf-input]');
        input.id = `CopiremaPdf-${this.dataset.sectionId}-${number}`;
        input.name = `properties[PDF tesi ${number} - ${copies} ${copies === 1 ? 'copia' : 'copie'}]`;
        row.querySelector('[data-pdf-title]').textContent = `PDF ${number}`;
        row.querySelector('[data-remove-pdf]').hidden = false;
      });
    }

    async analyzeRow(row) {
      const entry = this.entries.get(row);
      if (!entry?.file || !row.isConnected) return;
      this.clearError();
      const file = entry.file;
      const status = row.querySelector('[data-pdf-status]');
      if (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf') {
        status.textContent = 'File non valido';
        return this.showError(`${file.name}: seleziona un file PDF valido.`);
      }
      const maxMb = Number(this.dataset.maxNativeUploadMb || 20);
      if (maxMb > 0 && file.size > maxMb * 1024 * 1024) {
        status.textContent = 'File troppo grande';
        return this.showError(`${file.name} supera ${maxMb} MB. Riduci il peso del file prima di continuare.`);
      }

      entry.analyzing = true;
      this.progress.hidden = false;
      try {
        const pdfjs = this.getPdfEngine();
        const pdf = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
        await this.renderFirstPagePreview(row, pdf);
        const groups = { bw: [], gray: [], color: [] };
        for (let number = 1; number <= pdf.numPages; number += 1) {
          this.setProgress(number - 1, pdf.numPages, `${file.name}: pagina ${number} di ${pdf.numPages}…`);
          const page = await pdf.getPage(number);
          const inspection = classifyOperators(pdfjs, await page.getOperatorList());
          let pageClass = inspection.kind;
          if (inspection.needsRaster && pageClass !== 'color') {
            const base = page.getViewport({ scale: 1 });
            const scale = Math.min(2.1, 1400 / Math.max(base.width, base.height));
            const viewport = page.getViewport({ scale: Math.max(1.35, scale) });
            const canvas = document.createElement('canvas');
            canvas.width = Math.ceil(viewport.width);
            canvas.height = Math.ceil(viewport.height);
            const context = canvas.getContext('2d', { alpha: false, willReadFrequently: true });
            context.fillStyle = '#fff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            await page.render({ canvasContext: context, viewport }).promise;
            pageClass = strongestClass(pageClass, classifyPixels(context.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height));
          }
          groups[pageClass].push(number);
          page.cleanup();
          await new Promise(requestAnimationFrame);
        }
        const analysis = { total: pdf.numPages, bw: groups.bw.length, gray: groups.gray.length, color: groups.color.length };
        await pdf.destroy();
        if (entry.file !== file) return;
        entry.analysis = analysis;
        const colorPages = entry.analysis.color + entry.analysis.gray;
        status.textContent = `${entry.analysis.total} pagine · ${entry.analysis.bw} BN · ${colorPages} colore/grigi`;
      } catch (error) {
        console.error(error);
        if (entry.file === file) {
          entry.analysis = null;
          status.textContent = 'Analisi non riuscita';
          this.showError(error?.name === 'PasswordException'
              ? `${file.name}: il PDF è protetto da password.`
              : `${file.name}: non è stato possibile analizzare il PDF.`);
        }
      } finally {
        entry.analyzing = false;
        this.progress.hidden = true;
        this.renderAggregate();
      }
    }

    async renderFirstPagePreview(row, pdf) {
      const canvas = row.querySelector('[data-first-page-preview]');
      const box = row.querySelector('[data-frontespizio-check]');
      if (!canvas || !box || !pdf?.numPages) return;
      const page = await pdf.getPage(1);
      const base = page.getViewport({ scale: 1 });
      const scale = Math.min(1.35, 520 / Math.max(1, base.width));
      const viewport = page.getViewport({ scale: Math.max(0.75, scale) });
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const context = canvas.getContext('2d', { alpha: false });
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      await page.render({ canvasContext: context, viewport }).promise;
      page.cleanup();
      box.hidden = false;
    }

    updateDuplexWarning() {
      if (!this.duplexWarning) return;
      const duplex = this.printModeInput?.value === 'Fronte e retro';
      this.duplexWarning.hidden = !duplex;
      if (this.duplexConfirm) {
        this.duplexConfirm.required = duplex;
        if (!duplex) this.duplexConfirm.checked = false;
      }
    }

    frontespizioChoice(row) {
      return [...row.querySelectorAll('[data-frontespizio-choice]')].find((choice) => choice.checked)?.value || '';
    }

    validateFrontespizioChoices() {
      let firstInvalid = null;
      for (const row of this.entries.keys()) {
        const invalid = !this.frontespizioChoice(row);
        const inlineError = row.querySelector('[data-frontespizio-error]');
        const box = row.querySelector('[data-frontespizio-check]');
        if (inlineError) inlineError.hidden = !invalid;
        box?.classList.toggle('is-invalid', invalid);
        if (invalid && !firstInvalid) firstInvalid = row;
      }
      if (firstInvalid) {
        this.showError('Controlla la prima pagina di ogni PDF e seleziona una delle due opzioni sul frontespizio interno.');
        firstInvalid.querySelector('[data-frontespizio-check]')?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    frontespizioSummary() {
      return [...this.entries.keys()].map((row, index) => `${index + 1}. ${this.frontespizioChoice(row) === 'present' ? 'frontespizio presente nel PDF' : 'frontespizio interno non richiesto'}`).join(' · ');
    }

    validateDuplexConfirmation() {
      if (this.printModeInput?.value !== 'Fronte e retro') return true;
      if (this.duplexConfirm?.checked) return true;
      this.showError('Per la stampa fronte-retro conferma di aver controllato impaginazione, immagini, numeri di pagina e pagine bianche.');
      this.duplexWarning?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      return false;
    }

    async updateCoverPreview() {
      if (!this.coverPreviewText) return;
      const file = this.wordInput?.files?.[0];
      if (!file) {
        this.coverPreviewText.innerHTML = '<span>Carica il file Word per visualizzare un’anteprima indicativa del testo.</span>';
        if (this.coverPreviewStatus) this.coverPreviewStatus.textContent = 'L’anteprima è indicativa: la bozza definitiva verrà preparata da Copirema e inviata via email per l’approvazione.';
        return;
      }
      const name = (file.name || '').toLowerCase();
      if (!name.endsWith('.docx')) {
        this.coverPreviewText.innerHTML = '<span>Anteprima testuale non disponibile per i file .doc. Il file verrà comunque sistemato da Copirema dopo l’ordine.</span>';
        this.updateEngravingPreview();
        return;
      }
      try {
        const lines = await this.extractDocxParagraphs(file);
        const useful = lines.filter(Boolean).slice(0, 14);
        if (!useful.length) throw new Error('Testo non rilevato');
        this.coverPreviewText.replaceChildren(...useful.map((line) => {
          const span = document.createElement('span');
          span.textContent = line;
          return span;
        }));
        if (this.coverPreviewStatus) this.coverPreviewStatus.textContent = 'Anteprima indicativa del testo del Word. La bozza definitiva verrà impaginata da Copirema e inviata via email per l’approvazione.';
      } catch (error) {
        console.warn('Anteprima Word non disponibile', error);
        this.coverPreviewText.innerHTML = '<span>Il Word è stato caricato. L’anteprima testuale non è disponibile per questo file, ma riceverai la bozza definitiva via email prima della produzione.</span>';
      }
      this.updateEngravingPreview();
    }

    async extractDocxParagraphs(file) {
      const buffer = await file.arrayBuffer();
      const bytes = new Uint8Array(buffer);
      const view = new DataView(buffer);
      let eocd = -1;
      for (let i = Math.max(0, bytes.length - 65557); i <= bytes.length - 22; i += 1) {
        if (view.getUint32(i, true) === 0x06054b50) eocd = i;
      }
      if (eocd < 0) throw new Error('DOCX non valido');
      const entries = view.getUint16(eocd + 10, true);
      let offset = view.getUint32(eocd + 16, true);
      const decoder = new TextDecoder('utf-8');
      for (let index = 0; index < entries; index += 1) {
        if (view.getUint32(offset, true) !== 0x02014b50) throw new Error('Archivio DOCX non valido');
        const method = view.getUint16(offset + 10, true);
        const compressedSize = view.getUint32(offset + 20, true);
        const nameLength = view.getUint16(offset + 28, true);
        const extraLength = view.getUint16(offset + 30, true);
        const commentLength = view.getUint16(offset + 32, true);
        const localOffset = view.getUint32(offset + 42, true);
        const name = decoder.decode(bytes.slice(offset + 46, offset + 46 + nameLength));
        if (name === 'word/document.xml') {
          const localNameLength = view.getUint16(localOffset + 26, true);
          const localExtraLength = view.getUint16(localOffset + 28, true);
          const start = localOffset + 30 + localNameLength + localExtraLength;
          const compressed = bytes.slice(start, start + compressedSize);
          let xmlBytes;
          if (method === 0) {
            xmlBytes = compressed;
          } else if (method === 8 && 'DecompressionStream' in window) {
            const stream = new Blob([compressed]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
            xmlBytes = new Uint8Array(await new Response(stream).arrayBuffer());
          } else {
            throw new Error('Compressione DOCX non supportata dal browser');
          }
          const xml = decoder.decode(xmlBytes);
          const doc = new DOMParser().parseFromString(xml, 'application/xml');
          return [...doc.getElementsByTagNameNS('*', 'p')].map((paragraph) =>
            [...paragraph.getElementsByTagNameNS('*', 't')].map((node) => node.textContent || '').join('').trim()
          ).filter(Boolean);
        }
        offset += 46 + nameLength + extraLength + commentLength;
      }
      throw new Error('Documento Word non trovato nel DOCX');
    }

    engravingSelection() {
      if (!this.form?.elements) return '';
      for (const element of [...this.form.elements]) {
        const name = `${element.name || ''} ${element.id || ''}`.toLowerCase();
        if (!/(incision|scritta)/i.test(name)) continue;
        if ((element.type === 'radio' || element.type === 'checkbox') && !element.checked) continue;
        const value = String(element.value || '').trim();
        if (value) return value;
      }
      return '';
    }

    engravingCssColor(value) {
      const text = String(value || '').toLowerCase();
      if (/argento|silver/.test(text)) return '#c7c7c7';
      if (/nero|black/.test(text)) return '#111111';
      if (/bianco|white/.test(text)) return '#ffffff';
      if (/fucsia|pink|rosa/.test(text)) return '#d81b60';
      if (/rosso|red/.test(text)) return '#a31621';
      if (/blu|blue/.test(text)) return '#174a8b';
      if (/verde|green/.test(text)) return '#326b45';
      if (/rame|copper/.test(text)) return '#b87333';
      if (/bronzo|bronze/.test(text)) return '#8c6239';
      return '#c6a03a';
    }

    updateEngravingPreview() {
      if (!this.coverPreviewText) return;
      const selection = this.engravingSelection();
      const color = this.engravingCssColor(selection);
      this.coverPreviewText.style.color = color;
      this.coverPreviewText.classList.toggle('is-light-engraving', color === '#ffffff' || color === '#c7c7c7');
      if (selection && this.coverPreviewStatus) this.coverPreviewStatus.textContent = `Anteprima indicativa con incisione “${selection}”. La bozza definitiva verrà impaginata da Copirema e inviata via email per l’approvazione.`;
    }

    getPdfEngine() {
      if (!window.pdfjsLib) throw new Error('Motore PDF non disponibile');
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = this.dataset.workerUrl;
      return window.pdfjsLib;
    }

    allFilesReady() {
      return this.entries.size > 0 && [...this.entries.values()].every((entry) => entry.file && entry.analysis && !entry.analyzing);
    }

    calculateTotals() {
      const totals = { pdfCount: this.entries.size, copies: 0, printedPages: 0, bwUnits: 0, colorUnits: 0 };
      const allBw = this.colorModeInput.value === 'all-bw';
      for (const [row, entry] of this.entries) {
        const copies = this.getRowCopies(row);
        totals.copies += copies;
        if (!entry.analysis) continue;
        const printed = entry.analysis.total * copies;
        totals.printedPages += printed;
        if (allBw) totals.bwUnits += printed;
        else {
          totals.bwUnits += entry.analysis.bw * copies;
          totals.colorUnits += (entry.analysis.color + entry.analysis.gray) * copies;
        }
      }
      return totals;
    }

    updateCoverTotal(copies) {
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const unitPrice = this.coverVariants.get(String(variantId));
      const box = this.querySelector('[data-cover-total-box]');
      if (!box || !unitPrice) return;
      box.hidden = false;
      this.querySelector('[data-cover-copies]').textContent = String(copies);
      this.querySelector('[data-cover-unit-price]').textContent = formatMoney(unitPrice);
      this.renderPromotionPreview(copies, unitPrice);
    }

    renderPromotionPreview(copies, unitPrice) {
      const existingCounts = Object.fromEntries(COVER_DISCOUNT_GROUPS.map((group) => [group.key, 0]));
      let existingCoverCopies = 0;
      for (const item of this.cartData?.items || []) {
        const sku = String(item.sku || '').toUpperCase();
        const isPrintLine = sku.startsWith('COP-');
        const isThesisCover = !isPrintLine && Boolean(item.properties?.['_Riferimento lavorazione']);
        if (isThesisCover) existingCoverCopies += Math.max(0, Number(item.quantity || 0));

        const group = discountGroupFor(item.product_title || item.title || '');
        if (!group) continue;
        existingCounts[group.key] += Math.max(0, Number(item.quantity || 0));
      }

      const existingDiscount = COVER_DISCOUNT_GROUPS.reduce((best, group) =>
        Math.max(best, discountForQuantity(group.rates, existingCounts[group.key])), 0);

      const projectedCounts = { ...existingCounts };
      const currentGroup = discountGroupFor(this.dataset.productTitle || '');
      if (currentGroup) projectedCounts[currentGroup.key] += copies;

      const projectedDiscount = COVER_DISCOUNT_GROUPS.reduce((best, group) =>
        Math.max(best, discountForQuantity(group.rates, projectedCounts[group.key])), 0);

      const incrementalDiscount = Math.max(0, projectedDiscount - existingDiscount);
      const grossCoverCents = Number(unitPrice) * copies;
      const netCoverCents = Math.max(0, grossCoverCents - incrementalDiscount);
      const totalCoverCopies = existingCoverCopies + copies;
      const shippingCents = totalCoverCopies >= 2 ? 0 : 500;

      this.currentCoverNetCents = netCoverCents;
      this.currentShippingCents = shippingCents;

      const netValue = this.querySelector('[data-cover-total]');
      if (netValue) netValue.textContent = formatMoney(netCoverCents);

      const grossValue = this.querySelector('[data-cover-gross]');
      if (grossValue) {
        grossValue.hidden = incrementalDiscount <= 0;
        grossValue.textContent = formatMoney(grossCoverCents);
      }

      const discountNote = this.querySelector('[data-cover-discount-note]');
      const discountValue = this.querySelector('[data-discount-preview]');
      if (discountNote && discountValue) {
        discountNote.hidden = incrementalDiscount <= 0;
        discountValue.textContent = `−${formatMoney(incrementalDiscount)}`;
      }

      const shipping = this.querySelector('[data-shipping-preview]');
      if (shipping) shipping.textContent = shippingCents === 0 ? 'GRATUITA' : formatMoney(shippingCents);

      const shippingPromo = this.querySelector('[data-shipping-promo]');
      if (shippingPromo) {
        shippingPromo.textContent = shippingCents === 0
          ? 'Promo 2 o più copie applicata.'
          : 'Acquista almeno 2 copie e hai la spedizione gratuita.';
      }

      this.updateEstimatedTotal(this.currentPrintTotalCents || 0);
    }

    updateEstimatedTotal(printCents) {
      this.currentPrintTotalCents = Number(printCents || 0);
      const total = Number(this.currentCoverNetCents || 0) + this.currentPrintTotalCents + Number(this.currentShippingCents || 0);
      const totalNode = this.querySelector('[data-order-total]');
      if (totalNode) totalNode.textContent = formatMoney(total);
    }

    renderAggregate() {
      this.renumberRows();
      this.applyPaperRules();
      const totals = this.calculateTotals();
      if (this.quantityInput) this.quantityInput.value = String(Math.max(1, totals.copies));
      this.updateCoverTotal(Math.max(1, totals.copies));
      if (!this.validatePhysicalSheetLimit()) { this.result.hidden = true; return; }
      if (!this.allFilesReady()) { this.result.hidden = true; return; }
      const paper = this.paperInput.value;
      const bwVariant = this.variants.get(`COP-${paper}-BN`);
      const colorVariant = this.variants.get(`COP-${paper}-COLORE`);
      if (!bwVariant || !colorVariant) return this.showError('Tariffe di stampa non configurate per la carta selezionata.');
      const totalCents = totals.bwUnits * Number(bwVariant.price) + totals.colorUnits * Number(colorVariant.price);
      const detail = this.colorModeInput.value === 'all-bw'
        ? `${totals.bwUnits} pagine tutte in BN × ${formatMoney(bwVariant.price)}`
        : `${totals.bwUnits} pagine BN × ${formatMoney(bwVariant.price)} + ${totals.colorUnits} pagine colore × ${formatMoney(colorVariant.price)}`;
      this.querySelector('[data-pdf-count]').textContent = totals.pdfCount;
      this.querySelector('[data-copy-count]').textContent = totals.copies;
      this.querySelector('[data-total-pages]').textContent = totals.printedPages;
      this.querySelector('[data-bw-count]').textContent = totals.bwUnits;
      this.querySelector('[data-color-count]').textContent = totals.colorUnits;
      this.querySelector('[data-summary-paper]').textContent = `Carta: ${PAPER_LABELS[paper]}`;
      this.querySelector('[data-price-detail]').textContent = detail;
      this.querySelector('[data-print-total]').textContent = formatMoney(totalCents);
      this.updateEstimatedTotal(totalCents);
      this.querySelector('[data-property-paper]').value = PAPER_LABELS[paper];
      this.querySelector('[data-property-counts]').value = truncate(`${totals.printedPages} pagine: ${totals.bwUnits} BN + ${totals.colorUnits} colore/grigi`, 240);
      this.querySelector('[data-property-files]').value = truncate(this.fileSummary(), 240);
      this.querySelector('[data-property-price]').value = formatMoney(totalCents);
      this.result.hidden = false;
    }

    updateColorHelp() {
      this.querySelector('[data-property-color]').value = this.colorModeInput.options[this.colorModeInput.selectedIndex].text;
      this.querySelector('[data-color-help]').textContent = this.colorModeInput.value === 'all-bw'
        ? 'Tutte le pagine di tutti i PDF saranno conteggiate con la tariffa bianco e nero.'
        : 'Solo le pagine contenenti colori o elementi in scala di grigi saranno tariffate a colori. Le restanti saranno tariffate in bianco e nero.';
    }

    sheetsForPages(pages) {
      return sheetCount(pages, this.printModeInput?.value === 'Fronte e retro');
    }

    updateRowStatuses() {
      for (const [row, entry] of this.entries) {
        if (!entry.analysis) continue;
        const colorPages = entry.analysis.color + entry.analysis.gray;
        row.querySelector('[data-pdf-status]').textContent = `${entry.analysis.total} pagine · ${entry.analysis.bw} BN · ${colorPages} colore/grigi`;
      }
    }

    validatePhysicalSheetLimit() {
      if (!this.entries.size) return true;
      for (const [, entry] of this.entries) {
        if (!entry.analysis) continue;
        const sheets = this.sheetsForPages(entry.analysis.total);
        if (sheets > 330) {
          const mode = this.printModeInput.value === 'Fronte e retro' ? 'fronte/retro' : 'solo fronte';
          this.showError(`Con la modalità ${mode}, uno dei PDF richiede ${sheets} fogli. Il limite massimo è 330 fogli. ${this.printModeInput.value === 'Solo fronte' ? 'Prova a selezionare la stampa fronte/retro.' : 'Riduci il numero di pagine del PDF.'}`);
          return false;
        }
      }
      if (this.errorBox?.textContent?.includes('Il limite massimo è 330 fogli')) this.clearError();
      return true;
    }

    applyPaperRules() {
      const analyses = [...this.entries.values()].map((entry) => entry.analysis).filter(Boolean);
      const options = [...this.paperInput.options];
      if (!analyses.length) {
        options.forEach((option) => {
          option.disabled = false;
          if (option.dataset.baseLabel) option.textContent = option.dataset.baseLabel;
        });
        this.paperNotice.hidden = true;
        return true;
      }

      const maxSheets = Math.max(...analyses.map((analysis) => this.sheetsForPages(analysis.total)));
      const policy = paperPolicy(maxSheets);
      options.forEach((option) => {
        if (!option.dataset.baseLabel) option.dataset.baseLabel = option.textContent;
        const isStandard80 = option.value === '80';
        const isRecycled80 = option.value === '80-RICICLATA';
        const is120 = option.value === '120-OPACO' || option.value === '120-LUCIDO';
        option.disabled = policy.onlyStandard80
          ? !isStandard80
          : (policy.no120 && is120) || (policy.noRecycled && isRecycled80);
        option.textContent = `${option.dataset.baseLabel}${option.disabled ? ' — non disponibile per questo numero di fogli' : ''}`;
      });

      if (this.paperInput.selectedOptions[0]?.disabled) {
        const selectedPaper = this.paperInput.value;
        this.paperInput.value = policy.onlyStandard80 || selectedPaper === '80-RICICLATA' ? '80' : '100-OPACO';
      }

      const isSelected80 = this.paperInput.value === '80' || this.paperInput.value === '80-RICICLATA';
      if (policy.onlyStandard80) {
        this.setPaperNotice(`Il PDF più lungo richiede ${maxSheets} fogli. Oltre 260 fogli è disponibile soltanto la carta 80 grammi standard.`);
      } else if (policy.noRecycled) {
        this.setPaperNotice(`Il PDF più lungo richiede ${maxSheets} fogli. La carta 120 grammi non è disponibile oltre 80 fogli e la carta 80 grammi riciclata è disponibile fino a 130 fogli. Puoi scegliere la carta 80 grammi standard o una carta da 100 grammi.`);
      } else if (policy.no120) {
        this.setPaperNotice(`Il PDF più lungo richiede ${maxSheets} fogli. Oltre 80 fogli la carta 120 grammi non è disponibile; puoi scegliere 80 o 100 grammi.`);
      } else if (maxSheets < 50 && isSelected80) {
        this.setPaperNotice('Per una tesi sotto i 50 fogli consigliamo la carta 120 grammi, più consistente. Il consiglio è facoltativo: puoi mantenere la carta scelta.');
      } else {
        this.paperNotice.hidden = true;
        this.paperNotice.textContent = '';
      }
      return !this.paperInput.selectedOptions[0]?.disabled;
    }

    setPaperNotice(message) {
      this.paperNotice.textContent = message;
      this.paperNotice.hidden = false;
    }

    async refreshWordState() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Carrello non disponibile');
        const cart = await response.json();
        this.cartData = cart;
        const alreadyPresent = cart.items.some((item) => item.properties?.['Frontespizio Word']);
        this.wordAlreadyInCart = alreadyPresent;
        this.wordInput.disabled = alreadyPresent;
        this.wordInput.required = !alreadyPresent;
        this.wordField.hidden = alreadyPresent;
        this.wordPresent.hidden = !alreadyPresent;

        const existingPhone = cart.items.map((item) => item.properties?.['Telefono ordine']).find(Boolean) || '';
        this.contactAlreadyInCart = Boolean(existingPhone);
        if (this.orderPhoneInput) {
          this.orderPhoneInput.disabled = this.contactAlreadyInCart;
          this.orderPhoneInput.required = !this.contactAlreadyInCart;
          if (!this.contactAlreadyInCart && existingPhone) this.orderPhoneInput.value = existingPhone;
        }
        if (this.contactSection) this.contactSection.hidden = this.contactAlreadyInCart;
        if (this.contactPresent) this.contactPresent.hidden = !this.contactAlreadyInCart;
        if (!this.miniThesis) this.updateCoverTotal(Math.max(1, this.calculateTotals().copies || 1));
        return alreadyPresent;
      } catch (error) {
        console.error('Controllo frontespizio non riuscito', error);
        this.wordAlreadyInCart = false;
        this.wordInput.disabled = false;
        this.wordInput.required = true;
        this.wordField.hidden = false;
        this.wordPresent.hidden = true;
        this.contactAlreadyInCart = false;
        if (this.orderPhoneInput) { this.orderPhoneInput.disabled = false; this.orderPhoneInput.required = true; }
        if (this.contactSection) this.contactSection.hidden = false;
        if (this.contactPresent) this.contactPresent.hidden = true;
        return false;
      }
    }

    getRowCopies(row) {
      return Math.max(1, Math.min(99, parseInt(row.querySelector('[data-pdf-copies]')?.value || '1', 10) || 1));
    }

    fileSummary() {
      return [...this.entries].map(([row, entry], i) => {
        const sheets = entry.analysis ? `, ${this.sheetsForPages(entry.analysis.total)} fogli` : '';
        return `${i + 1}. ${entry.file?.name || 'PDF mancante'} (${this.getRowCopies(row)} copie${sheets})`;
      }).join(' · ');
    }

    async onSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitting) return;
      this.clearError();
      if (this.miniThesis) return this.submitMiniThesis();
      if (!this.hasCompleteVariantMap()) return this.showError('Il servizio di stampa non è ancora configurato.');
      if (!this.allFilesReady()) return this.showError('Carica almeno un PDF e attendi il completamento di tutte le analisi.');
      if (!this.validateFrontespizioChoices()) return;
      if (!this.validateDuplexConfirmation()) return;
      await this.refreshWordState();
      if (!this.wordAlreadyInCart && !this.wordInput?.files?.length) return this.showError('Carica il frontespizio in Word per la copertina esterna.');
      if (!this.contactAlreadyInCart && !this.orderPhoneInput?.value?.trim()) return this.showError('Inserisci il numero di telefono: è obbligatorio anche per il ritiro in negozio.');
      if (!this.validatePhysicalSheetLimit()) return;
      if (!this.applyPaperRules()) return this.showError('La carta selezionata non è compatibile con il numero di fogli.');
      if (!this.form.reportValidity()) return;

      this.submitting = true;
      const submit = this.form.querySelector('[type="submit"]');
      submit?.classList.add('loading');
      submit?.setAttribute('aria-disabled', 'true');
      const jobId = `TESI-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
      try {
        this.renderAggregate();
        const totals = this.calculateTotals();
        const items = [];
        if (totals.colorUnits) items.push(this.printItem(`COP-${this.paperInput.value}-COLORE`, totals.colorUnits, jobId, totals));
        if (totals.bwUnits) items.push(this.printItem(`COP-${this.paperInput.value}-BN`, totals.bwUnits, jobId, totals));
        if (items.length) {
          const printResponse = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
          });
          const printResult = await printResponse.json();
          if (!printResponse.ok || printResult.status) throw new Error(printResult.description || 'Impossibile aggiungere le stampe.');
        }

        const formData = new FormData(this.form);
        formData.append('properties[_Riferimento lavorazione]', jobId);
        formData.append('properties[PDF e copie]', truncate(this.fileSummary(), 240));
        formData.append('properties[Frontespizio interno]', truncate(this.frontespizioSummary(), 240));
        const coverResponse = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData
        });
        const cover = await coverResponse.json();
        if (!coverResponse.ok || cover.status) throw new Error(cover.description || 'Impossibile aggiungere la copertina.');
        window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
      } catch (error) {
        console.error(error);
        await this.rollbackJob(jobId);
        this.showError(error.message || 'Si è verificato un errore. Riprova.');
        this.submitting = false;
        submit?.classList.remove('loading');
        submit?.removeAttribute('aria-disabled');
      }
    }

    async submitMiniThesis() {
      await this.refreshWordState();
      if (!this.wordAlreadyInCart && !this.wordInput?.files?.length) return this.showError('Carica il frontespizio in Word per la copertina esterna.');
      if (!this.contactAlreadyInCart && !this.orderPhoneInput?.value?.trim()) return this.showError('Inserisci il numero di telefono: è obbligatorio anche per il ritiro in negozio.');
      if (!this.form.reportValidity()) return;

      this.submitting = true;
      const submit = this.form.querySelector('[type="submit"]');
      submit?.classList.add('loading');
      submit?.setAttribute('aria-disabled', 'true');
      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Impossibile aggiungere la Mini Tesi.');
        window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
      } catch (error) {
        console.error(error);
        this.showError(error.message || 'Si è verificato un errore. Riprova.');
        this.submitting = false;
        submit?.classList.remove('loading');
        submit?.removeAttribute('aria-disabled');
      }
    }

    printItem(sku, quantity, jobId, totals) {
      return { id: this.variants.get(sku).id, quantity, properties: {
        '_Riferimento lavorazione': jobId, 'Carta': PAPER_LABELS[this.paperInput.value],
        'Scelta colore': this.colorModeInput.options[this.colorModeInput.selectedIndex].text,
        'PDF e copie': truncate(this.fileSummary(), 240), 'Copie complessive': totals.copies
      } };
    }

    async rollbackJob(jobId) {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const createdItems = cart.items.filter((item) => item.properties?.['_Riferimento lavorazione'] === jobId);
        for (const item of createdItems) {
          await fetch(window.routes?.cart_change_url || `${root}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
      } catch (error) { console.error('Rollback carrello non riuscito', error); }
    }

    hideBypassButtons() {
      const dynamicButton = this.form?.closest('product-form')?.querySelector('.shopify-payment-button');
      if (dynamicButton) dynamicButton.hidden = true;
      document.querySelectorAll('.sticky-cart').forEach((element) => { element.hidden = true; });
    }
    disablePurchase() {
      const button = this.form?.querySelector('[type="submit"]');
      if (button) { button.disabled = true; button.setAttribute('aria-disabled', 'true'); }
    }
    setProgress(done, total, label) {
      const percent = total ? Math.round(done / total * 100) : 0;
      this.querySelector('[data-progress-label]').textContent = label;
      this.querySelector('[data-progress-percent]').textContent = `${percent}%`;
      this.querySelector('[data-progress-bar]').style.width = `${percent}%`;
    }
    showError(message) { this.errorBox.textContent = message; this.errorBox.hidden = false; }
    clearError() { this.errorBox.hidden = true; this.errorBox.textContent = ''; }
  }


  function normalizeProductName(value) {
    return String(value || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function discountGroupFor(title) {
    const normalized = normalizeProductName(title);
    return COVER_DISCOUNT_GROUPS.find((group) => group.normalized.has(normalized)) || null;
  }
  function discountForQuantity(rates, quantity) {
    if (quantity >= 5) return rates[5] || 0;
    if (quantity >= 4) return rates[4] || 0;
    if (quantity >= 3) return rates[3] || 0;
    if (quantity >= 2) return rates[2] || 0;
    return 0;
  }

  function classifyOperators(pdfjs, operatorList) {
    const O = pdfjs.OPS;
    let state = { fill: 'bw', stroke: 'bw', textMode: 0 }, kind = 'bw', needsRaster = false;
    const stack = [];
    const use = (paint) => { if (paint === 'complex') needsRaster = true; else kind = strongestClass(kind, paint); };
    const useText = () => {
      if ([0, 2, 4, 6].includes(state.textMode)) use(state.fill);
      if ([1, 2, 5, 6].includes(state.textMode)) use(state.stroke);
    };
    const visibleText = (args) => {
      const chunks = args?.[0];
      return !Array.isArray(chunks) || chunks.some((item) => item && typeof item === 'object' && !item.isSpace && /[^\s\u0000-\u001f]/u.test(item.unicode || ''));
    };
    const imageOps = new Set([O.paintImageXObject, O.paintInlineImageXObject, O.paintImageXObjectRepeat, O.paintInlineImageXObjectGroup]);
    for (let i = 0; i < operatorList.fnArray.length; i += 1) {
      const fn = operatorList.fnArray[i], args = operatorList.argsArray[i];
      if (fn === O.save) stack.push({ ...state });
      else if (fn === O.restore && stack.length) state = stack.pop();
      else if (fn === O.setFillRGBColor) state.fill = colorClass(args);
      else if (fn === O.setStrokeRGBColor) state.stroke = colorClass(args);
      else if (fn === O.setFillColorN) state.fill = 'complex';
      else if (fn === O.setStrokeColorN) state.stroke = 'complex';
      else if (fn === O.setTextRenderingMode) state.textMode = args?.[0] ?? 0;
      else if (imageOps.has(fn) || fn === O.shadingFill) needsRaster = true;
      else if (fn === O.paintImageMaskXObject || fn === O.paintSolidColorImageMask) use(state.fill);
      else if (fn === O.stroke || fn === O.closeStroke) use(state.stroke);
      else if (fn === O.fill || fn === O.eoFill) use(state.fill);
      else if ([O.fillStroke, O.eoFillStroke, O.closeFillStroke, O.closeEOFillStroke].includes(fn)) { use(state.fill); use(state.stroke); }
      else if ([O.showText, O.showSpacedText, O.nextLineShowText, O.nextLineSetSpacingShowText].includes(fn) && visibleText(args)) useText();
    }
    return { kind, needsRaster };
  }
  function colorClass(v) {
    if (!v || v.length < 3) return 'complex';
    const hi = Math.max(+v[0], +v[1], +v[2]), lo = Math.min(+v[0], +v[1], +v[2]);
    if (lo >= 250) return 'bw';
    if (hi - lo >= 8) return 'color';
    return hi <= 5 ? 'bw' : 'gray';
  }
  function strongestClass(a, b) { return ({ bw: 0, gray: 1, color: 2 })[b] > ({ bw: 0, gray: 1, color: 2 })[a] ? b : a; }
  function classifyPixels(data, width, height) {
    let colored = 0, gray = 0, marked = 0;
    const dark = new Uint8Array(width * height);
    for (let i = 0, p = 0; i < data.length; i += 4, p += 1) {
      const r = data[i], g = data[i + 1], b = data[i + 2], hi = Math.max(r, g, b), lo = Math.min(r, g, b);
      if (lo >= 251) continue;
      marked += 1;
      const light = (r * 299 + g * 587 + b * 114) / 1000;
      if (hi - lo >= 14 && light < 254) colored += 1;
      if (light <= 38) dark[p] = 1;
    }
    if (colored > Math.max(10, Math.floor(marked * 0.00015))) return 'color';
    for (let i = 0, p = 0; i < data.length; i += 4, p += 1) {
      const r = data[i], g = data[i + 1], b = data[i + 2];
      if (Math.max(r, g, b) - Math.min(r, g, b) >= 14) continue;
      const light = (r * 299 + g * 587 + b * 114) / 1000;
      if (light <= 42 || light >= 250) continue;
      const x = p % width, y = Math.floor(p / width);
      let nearBlack = false;
      for (let dy = -2; dy <= 2 && !nearBlack; dy += 1) {
        const yy = y + dy;
        if (yy < 0 || yy >= height) continue;
        for (let dx = -2; dx <= 2; dx += 1) {
          const xx = x + dx;
          if (xx >= 0 && xx < width && dark[yy * width + xx]) { nearBlack = true; break; }
        }
      }
      if (!nearBlack) gray += 1;
    }
    return gray > Math.max(12, Math.floor(marked * 0.00025)) ? 'gray' : 'bw';
  }
  function formatMoney(cents) { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(+cents / 100); }
  function truncate(value, max) { return value.length <= max ? value : `${value.slice(0, max - 1)}…`; }
  function sheetCount(pages, duplex) { return duplex ? Math.ceil(pages / 2) : pages; }
  function paperPolicy(sheets) {
    return {
      onlyStandard80: sheets > 260,
      noRecycled: sheets > 130,
      no120: sheets > 80,
      recommend120: sheets < 50
    };
  }
  Object.defineProperty(window, '__COPIREMA_THESIS_TEST__', { value: { sheetCount, paperPolicy }, configurable: true });
  customElements.define('copirema-thesis-calculator', CopiremaThesisCalculator);
})();

(() => {
  const refreshCopiremaWizardLinks = () => {
    document.querySelectorAll('[data-copirema-wizard-link]').forEach((link) => {
      const form = link.closest('.product__info-container')?.querySelector('form[data-type="add-to-cart-form"]');
      const variantId = form?.querySelector('input[name="id"]')?.value || new URL(link.href).searchParams.get('cover_variant') || '';
      try {
        const url = new URL(link.href, window.location.origin);
        const values = {
          cover: link.dataset.coverHandle || '',
          cover_id: link.dataset.coverId || '',
          cover_title: link.dataset.coverTitle || '',
          cover_url: link.dataset.coverUrl || '',
          cover_image: link.dataset.coverImage || '',
          cover_variant: variantId
        };
        Object.entries(values).forEach(([key, value]) => value && url.searchParams.set(key, value));
        link.href = `${url.pathname}${url.search}`;
      } catch (_) {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCopiremaWizardLinks);
  else refreshCopiremaWizardLinks();
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-radios, variant-selects, .product-form__input')) setTimeout(refreshCopiremaWizardLinks, 0);
  });
})();
